import { normalize } from 'normalizr';

import * as entities from './entities';

export const types = {
  FETCH_PROCESSES: 'processes/FETCH_PROCESSES',
};
// type FetchProcessesAction = {
//   type: typeof types.FETCH_PROCESSES,
//   payload: NormalizedArray,
// };
export const fetchProcesses = (payload) => ({
  type: types.FETCH_PROCESSES,
  payload: normalize(payload, [entities.processSchema]),
});
